import { LargeVisionActionTypes } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { PlaylistTop } from '../../types'

/**
 * Large Vision top playlist reducer
 */
const largeVisionPlaylistTop = buildAsyncStatReducer({
    key: Metrics.LARGEVISION_PLAYLIST_TOP,
    types: {
        request: LargeVisionActionTypes.DASHBOARD_LARGEVISION_PLAYLIST_TOP.request,
        success: LargeVisionActionTypes.DASHBOARD_LARGEVISION_PLAYLIST_TOP.success,
        failure: LargeVisionActionTypes.DASHBOARD_LARGEVISION_PLAYLIST_TOP.failure,
    },
    transform: (state, { payload = [] }): PlaylistTop => {
        const { content, count } = payload[0] || {}
        return { id: content, name: content, icon: null, total: count }
    },
})

export default largeVisionPlaylistTop
